import { render, staticRenderFns } from "./InspectionSerialNumberAnomaly.vue?vue&type=template&id=8191cb36&scoped=true&"
import script from "./InspectionSerialNumberAnomaly.vue?vue&type=script&lang=ts&"
export * from "./InspectionSerialNumberAnomaly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8191cb36",
  null
  
)

export default component.exports